<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  margin: 0;
  min-width: 320px;
  background: #f4f7fb;
}

* {
  box-sizing: border-box;
}

button,
input,
textarea {
  font-family: inherit;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #25384b;
  min-height: 100vh;
}

.el-card,
.el-dialog,
.el-table,
.el-message,
.el-notification {
  font-family: inherit;
}
</style>
